export default __webpack_public_path__ + "static/media/music.d3693e57.mp3";